import { IntlProvider } from 'react-intl';
import messages from './en';

const locale = 'en';

// TODO investigate if there is a way to expose IntlProvider from index.tsx
export default new IntlProvider({ locale, messages }).getChildContext().intl;
